import { ascending } from '../constants/sortDirections';

const sortByAsc = (a, b) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

const sortByPropAsc = (propName) => (a, b) => {
  return sortByAsc(a[propName], b[propName]);
};

const sortByDesc = (a, b) => {
  if (a > b) {
    return -1;
  }
  if (a < b) {
    return 1;
  }
  return 0;
};

const sortByPropDesc = (propName) => (a, b) => {
  return sortByDesc(a[propName], b[propName]);
};

const sortByLocale = (collator, direction) => (a, b) => {
  const comparisonResult = collator.compare(a, b);

  return direction === ascending ? comparisonResult : -1 * comparisonResult;
};

const sortBy =
  ({ direction, intlCollator, propName }) =>
  (a, b) => {
    const itemA = propName ? a[propName] : a;
    const itemB = propName ? b[propName] : b;

    if (intlCollator) {
      return sortByLocale(intlCollator, direction)(itemA, itemB);
    }

    return direction === ascending ? sortByAsc(itemA, itemB) : sortByDesc(itemA, itemB);
  };

export { sortByAsc, sortByPropAsc, sortByDesc, sortByPropDesc, sortBy };
